import {useAuthStore} from "@common/store/auth";
import {getPortailService} from "@common/services/portail.service";

const RoutesAUTH =
    [
        {
            name: 'Connexion',
            path: '/auth',
            component: () => import('@common/views/auth/Connexion.vue'),
            beforeEnter: async (to, from, next) => {

                if(useAuthStore().estConnecte) {
                    if(to.query.redirect) {
                        next(to.query.redirect as string);
                        return;
                    }
                    next('/');
                    return;
                }


                if(to.query.redirect) {
                    localStorage.setItem('redirectAfterLogin', to.query.redirect as string);
                }
                else if (from.name !== 'Connexion' && from.fullPath !== '/' && !to.query.code) {
                    localStorage.setItem('redirectAfterLogin',  from.fullPath);
                }

                next();
            }
        },
        {
            name: 'Déconnexion',
            path: '/logout',
            beforeEnter: async (to, from, next) => {
                getPortailService().deconnecter({invaliderJeton: true})
                next('/auth');
            }

        },
        {
          path: '/mot-de-passe-oublie',
          name: 'mot-de-passe-oublie',
          component: () => import('../views/auth/PageMotDePasseOublie.vue')
        },
        {
            path: '/reinitialisation-mot-de-passe/:token',
            name: 'reinitialisation-mot-de-passe',
            component: () => import('../views/auth/PageReinitialisationMotDePasse.vue')
        },

        {
            path: '/activation-compte-courriel',
            name: 'activation-compte-courriel',
            component: () => import('../views/auth/PageActivationCompteCourriel.vue')
        },
        {
          path: '/activation-compte-mot-de-passe/:token',
          name: 'activation-compte-mot-de-passe',
          component: () => import('../views/auth/PageActivationCompteMotDePasse.vue')
        },



    ]

export default RoutesAUTH